import { sessionStore } from "@/Globals/Stores/SessionStore";
import { CancellableWorkflowStep } from "../../BaseWorkflow/Steps/CancellableWorkflowStep";
import { LoginWorkflowStepEnum } from "../LoginWorkflowStepEnum";

class RequiredRecoveryEmailFlowStep extends CancellableWorkflowStep<LoginWorkflowStepEnum> {
    public constructor() {
        super(LoginWorkflowStepEnum.RequiredRecoveryEmailFlow);
    }

    public isValid(): boolean {
        return (
            (!sessionStore.hasEmail || sessionStore.unverifiedEmail)
            && !sessionStore.isRequiredEmailFlowEnded
            && sessionStore.isRecoveryEmailRequired
        );
    }

    public isCompleted(): boolean {
        return sessionStore.isRequiredEmailFlowEnded;
    }

    public cancel(): void {
        sessionStore.loginWorkflow.nextStep();
    }
}

export { RequiredRecoveryEmailFlowStep };
